export default "__VITE_ASSET__BMf4Sad___"